import { useCallback } from 'react';
import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { EMPLOYEE_QUERY_KEY } from '@/modules/employee/Employee/queries/useGetEmployeeByIdExtended.query';

const useConfirmAddressQuery = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (addressId: number) => api.post(`/addresses/${addressId}/confirm`), {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [EMPLOYEE_QUERY_KEY],
        });
      },
    },
  );

  const confirmAddress = useCallback(
    async (addressId: number) => {
      await mutation.mutateAsync(addressId);
    },
    [mutation],
  );

  return {
    confirmAddress,
    isLoading: mutation.isLoading,
  };
};

export default useConfirmAddressQuery;
